// File host for cancellation policy
export const FILE_HOST = import.meta.env.VITE_APP_FILE_HOST || '';
export const CANCELLATION_POLICY_LINK = `${import.meta.env.VITE_PUBLIC_URL}/cancellation-policy`;
export const LINE_ID_KUROBE = '1'; // 黒部本線
export const EMPTY_SYMBOL = '--';
export const PAGE_SIZE_50 = 50;
export const SEPARATOR = ',';
export const MAX_PARTICIPANT_COUNT = 999;
export const MIN_PARTICIPANT_COUNT = 1;
export const MAX_FEE = 9999;
export const SERVICE_DATE_RANGE = 29;

/** 最大文字数 */
export const CONTACT_NUMBER_MAX = 30;
export const NAME_MAX = 50;
export const EMAIL_MAX = 254;
export const PASSWORD_MAX = 64;
export const RATE_FIELD_MAX = 5;
export const INVOICE_NUMBER_MAX = 14;

export const MAX_LENGTH_100 = 100;
export const REMARK_MAX = 1000;
export const URL_MAX = 2000;
export const TICKET_ISSUER_MAX = 50; // 発行元の入力桁数上限（仕様: dMst04_S_Dsp01 項目定義）

export const MIN_PARTICIPANT_COUNT_FOR_BOOKING = 15;

export enum DirectionIdEnum {
  Up = 'UP',
  Down = 'DOWN'
}
export type DirectionId = DirectionIdEnum;

// 片道・往復の区別
export enum TripTypeEnum {
  Round = 'ROUND',
  Single = 'SINGLE'
}
export type TripType = TripTypeEnum;

// 行程区分（KNR/POS 共通：往路・復路）
export enum LegTypeEnum {
  OUTBOUND = 'OUTBOUND', // 往路（去程）
  RETURN = 'RETURN' // 復路（返程）
}
export type LegType = LegTypeEnum;

export enum SelectionRuleEnum {
  Normal = 'NORMAL', // 普通電車
  Connection = 'CONNECTION', // 接続電車
  Foldback = 'FOLDBACK' // 折返し電車
}
export type SelectionRule = SelectionRuleEnum;

export enum TrainAssignmentPublicStatusEnum {
  OutOfScope = 'OUT_OF_SCOPE', // 運行期間の対象外
  Unpublished = 'UNPUBLISHED', // 公開前
  Suspended = 'SUSPENDED', // 運休
  Published = 'PUBLISHED', // 公開
  PublishedStopped = 'PUBLISHED_STOPPED' // 公開停止
}
export type TrainAssignmentPublicStatus = TrainAssignmentPublicStatusEnum;

export enum SeatTypeDisplayStateEnum {
  Hidden = 'hidden', // 非表示
  Suspended = 'suspended', // 運休
  Available = 'available' // 利用可能
}
export type SeatTypeDisplayState = SeatTypeDisplayStateEnum;

/** 席付・座席表の座席表示状態。 */
export enum SeatDisplayStateEnum {
  Available = 'AVAILABLE', // 利用可能
  HeldByOther = 'HELD_BY_OTHER', // 他の予約者が席を確保
  SelectedByCurrent = 'SELECTED_BY_CURRENT', // 現在の予約者が席を選択
  AssignedByCurrent = 'ASSIGNED_BY_CURRENT', // 現在の予約者が席を割り当て
  NonSelectable = 'NON_SELECTABLE' // 選択不可
}
export type SeatDisplayState = SeatDisplayStateEnum;

/**
 * ユーザータイプ（後端 RoleScopeEnum と一致）
 * 各パッケージは独立して起動するため、天然でスコープが隔離されている
 */
export enum UserTypeEnum {
  KKT = 'KKT',
  Agency = 'AGENCY',
  Sales = 'SALES',
  Individual = 'INDIVIDUAL'
}
export type UserType = UserTypeEnum;

export enum LanguageCodeEnum {
  Ja = 'ja',
  En = 'en'
}
export type LanguageCode = LanguageCodeEnum;

// 曜日
export enum WeekTypeEnum {
  Sun = 0,
  Mon = 1,
  Tue = 2,
  Wed = 3,
  Thu = 4,
  Fri = 5,
  Sat = 6
}
export type WeekType = WeekTypeEnum;
export const weekTypeMap: Record<WeekType, string> = {
  [WeekTypeEnum.Sun]: 'sun',
  [WeekTypeEnum.Mon]: 'mon',
  [WeekTypeEnum.Tue]: 'tue',
  [WeekTypeEnum.Wed]: 'wed',
  [WeekTypeEnum.Thu]: 'thu',
  [WeekTypeEnum.Fri]: 'fri',
  [WeekTypeEnum.Sat]: 'sat'
};

/** 車両運休種類  todo: 修正*/
export enum TrainOperationStatusEnum {
  Normal = 'NORMAL', // 通常運行
  Suspended = 'SUSPENDED', // 運休
  PartialSuspended = 'PARTIAL_SUSPENDED' // 部分運休
}
export type TrainOperationStatus = TrainOperationStatusEnum;

/**
 * 列車の利用者区分（バックエンド契約未定の暫定値。結合試験時に確定する）
 * 関電社員・貨物の列車は予約画面に表示しない
 */
export enum TrainUserTypeEnum {
  General = 'GENERAL', // 一般
  KandenStaff = 'KANDEN_STAFF', // 関電社員
  Cargo = 'CARGO' // 貨物
}
export type TrainUserType = TrainUserTypeEnum;

/**
 * ユーザーロール（後端 UserRoleEnum と一致）
 * scope(KKT/AGENCY/SALES/INDIVIDUAL) × level(ADMIN/APPLICANT) の組み合わせ
 */
export enum UserRoleEnum {
  Admin = 'ADMIN',
  Applicant = 'APPLICANT'
}
export type UserRole = UserRoleEnum;

export enum UserGroupEnum {
  MERCHANDISE_MANAGEMENT_GROUP = '1', // 物販統括グループ （団体予約のみ）
  SALES_DEPARTMENT = '2', // 営業部
  TRANSPORTATION_STATION_STAFF = '3', // 運輸部駅担当
  KURONAGI_STATION_ASSISTANT = '4' // 黒薙駅補助係員 （駅務管理のみ）
}
export type UserGroup = UserGroupEnum;

export enum SeatClassTypeEnum {
  NORMAL = 'NORMAL',
  RELAX = 'RELAX'
}
export type SeatClassType = SeatClassTypeEnum;

export enum SeatClassTypeNameEnum {
  NORMAL = 'normal',
  RELAX = 'relax'
}
export type SeatClassTypeName = SeatClassTypeNameEnum;

/**
 * 座席図アイテム区分（itemType。既存座席図 API と共通）
 */
export enum SeatItemTypeEnum {
  Seat = 'seat', // 座席
  Conductor = 'conductor', // 車掌席
  Empty = 'empty' // 空きスペース（座席なし）
}
export type SeatItemType = SeatItemTypeEnum;

/**
 * KNR 座席図レイアウト要素区分（GET /knr/seat-map の seats[].itemType。数字）
 */
export enum KnrSeatItemTypeEnum {
  Seat = 1, // 座席
  Conductor = 2, // 車掌席
  Wheelchair = 3, // 車椅子席
  Empty = 4 // 空位
}
export type KnrSeatItemType = KnrSeatItemTypeEnum;

/**
 * 個券予約の券種コード（KNR 注文 items[].itemType。POS と共通）
 * ドキュメント: KNR接口设计.md 2.4
 * ※ KNR 作成で受け付けるのは片道/往復・優待・フリープランの 10 種。
 *   個人予約検索（GET /knr/orders）のレスポンスでは入場券・荷物券・定期券等も
 *   返却されるため、それらの値も同じ enum に集約する（KNR接口设计.md 第7章）
 */
export enum TicketItemTypeEnum {
  SingleNormalTicket = 'SINGLE_NORMAL_TICKET', // 片道普通個券
  SingleRelaxTicket = 'SINGLE_RELAX_TICKET', // 片道 Relax 個券
  RoundNormalTicket = 'ROUND_NORMAL_TICKET', // 往復普通個券
  RoundRelaxTicket = 'ROUND_RELAX_TICKET', // 往復 Relax 個券
  DiscountSingleNormalTicket = 'DISCOUNT_SINGLE_NORMAL_TICKET', // 優待片道普通乗車券
  DiscountRoundNormalTicket = 'DISCOUNT_ROUND_NORMAL_TICKET', // 優待往復普通乗車券
  FreePlanSingleNormalTicket = 'FREE_PLAN_SINGLE_NORMAL_TICKET', // フリープラン・片道普通
  FreePlanSingleRelaxTicket = 'FREE_PLAN_SINGLE_RELAX_TICKET', // フリープラン・片道 Relax
  FreePlanRoundNormalTicket = 'FREE_PLAN_ROUND_NORMAL_TICKET', // フリープラン・往復普通
  FreePlanRoundRelaxTicket = 'FREE_PLAN_ROUND_RELAX_TICKET', // フリープラン・往復 Relax
  AdmissionTicket = 'ADMISSION_TICKET', // 入場券（検索一覧のみ）
  HandBaggageTicket = 'HAND_BAGGAGE_TICKET', // 手回品券（検索一覧のみ）
  LargeBaggageTicket = 'LARGE_BAGGAGE_TICKET', // 大型荷物券（検索一覧のみ）
  TokutokuBasicTicket = 'TOKUTOKU_BASIC_TICKET', // トクトク基本券（検索一覧のみ）
  TokutokuPremiumTicket = 'TOKUTOKU_PREMIUM_TICKET', // トクトクプレミアム券（検索一覧のみ）
  CommuterPass = 'COMMUTER_PASS', // 通勤定期券（検索一覧のみ）
  AdmissionPass = 'ADMISSION_PASS' // 入場定期券（検索一覧のみ）
}
export type TicketItemType = TicketItemTypeEnum;

/**
 * KNR 個人予約検索（GET /knr/orders）の絞り込み列挙。
 * ドキュメント: KNR接口设计.md 第7章（列表口径は注文/支払共通列挙と別体系）
 */

/** 購入类别（purchaseCategory） */
export enum KnrPurchaseCategoryEnum {
  Online = 'ONLINE', // オンライン購入
  OnSite = 'ON_SITE' // 窓口・現地購入
}
export type KnrPurchaseCategory = KnrPurchaseCategoryEnum;

/** 予約状態（reservationStatus） */
export enum KnrReservationStatusEnum {
  Reserved = 'RESERVED', // 予約成立
  Cancelled = 'CANCELLED' // キャンセル済
}
export type KnrReservationStatus = KnrReservationStatusEnum;

/** 支払状態（paymentStatus。リスト口径は UNPAID/PAID の 2 値） */
export enum KnrOrderListPaymentStatusEnum {
  Unpaid = 'UNPAID', // 未払い
  Paid = 'PAID' // 支払済
}
export type KnrOrderListPaymentStatus = KnrOrderListPaymentStatusEnum;

/** 運行状態（operationStatus） */
export enum KnrOperationStatusEnum {
  Normal = 'NORMAL', // 通常運行
  Charter = 'CHARTER', // 貸切
  Suspended = 'SUSPENDED' // 運休
}
export type KnrOperationStatus = KnrOperationStatusEnum;

/** 統一注文詳細（GET /knr/orders/{orderId}）の受注元 sourceType */
export enum KnrOrderSourceTypeEnum {
  Pos = 'POS',
  Kbk = 'KBK',
  Knr = 'KNR',
  GroupBooking = 'GROUP_BOOKING',
  Online = 'ONLINE'
}
export type KnrOrderSourceType = KnrOrderSourceTypeEnum;

/** 票券種別（ticketTypes。QR / ハードカード） */
export enum KnrCredentialTypeEnum {
  Qr = 'QR',
  HardCard = 'HARD_CARD'
}
export type KnrCredentialType = KnrCredentialTypeEnum;

/**
 * 統一注文詳細 header.paymentStatus の DB 编码（KNR接口设计.md 8.1）。
 * ※ 订单摘要（UNPAID/PAID）・支払流水（PaymentStatusEnum）とは別口径の数値列挙
 */
export enum KnrHeaderPaymentStatusEnum {
  Unconfirmed = 0, // UNCONFIRMED
  AwaitingPayment = 1, // AWAITING_PAYMENT
  PaymentProcessing = 2, // PAYMENT_PROCESSING
  ProvisionalPaid = 3, // PROVISIONAL_PAID
  Paid = 4, // PAID
  PaymentFailed = 5, // PAYMENT_FAILED
  NoPaymentRequired = 6, // NO_PAYMENT_REQUIRED
  MonthlySettlement = 7 // MONTHLY_SETTLEMENT
}
export type KnrHeaderPaymentStatus = KnrHeaderPaymentStatusEnum;

/**
 * POS/KNR 共通の注文ステータス（orderStatus）
 * ドキュメント: KNR接口设计.md 2.5
 */
export enum PosOrderStatusEnum {
  Draft = 'DRAFT', // 作成済（支払前）
  PendingPayment = 'PENDING_PAYMENT', // 支払待ち
  Paid = 'PAID', // 支払済
  Issued = 'ISSUED', // 発券済
  Cancelled = 'CANCELLED', // キャンセル済
  Completed = 'COMPLETED' // 完了
}
export type PosOrderStatus = PosOrderStatusEnum;

/**
 * 決済ステータス（paymentStatus。KNR 注文系共通・8 値）
 * ドキュメント: KNR接口设计.md 2.5 / 6.1.3
 */
export enum PaymentStatusEnum {
  Unconfirmed = 'UNCONFIRMED', // 未確認
  AwaitingPayment = 'AWAITING_PAYMENT', // 支払待ち
  PaymentProcessing = 'PAYMENT_PROCESSING', // 支払処理中
  ProvisionalPaid = 'PROVISIONAL_PAID', // 仮支払済
  Paid = 'PAID', // 支払済
  PaymentFailed = 'PAYMENT_FAILED', // 支払失敗
  NoPaymentRequired = 'NO_PAYMENT_REQUIRED', // 支払いなし（優待券等）
  MonthlySettlement = 'MONTHLY_SETTLEMENT' // 月末精算
}
export type PaymentStatus = PaymentStatusEnum;

export enum CancellationStatusEnum {
  Requested = 'REQUESTED',
  Confirmed = 'CONFIRMED'
}
export type CancellationStatus = CancellationStatusEnum;

export enum SettlementStatusEnum {
  NotStarted = 'NOT_STARTED',
  NotRequired = 'NOT_REQUIRED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED',
  Failed = 'FAILED',
  ActionRequired = 'ACTION_REQUIRED'
}
export type SettlementStatus = SettlementStatusEnum;

/**
 * 支払タイミング（KNR 注文作成の paymentTiming。必須・デフォルト値なし）
 * ドキュメント: KNR接口设计.md 5.2
 */
export enum PaymentTimingEnum {
  Immediate = 'IMMEDIATE', // 即時支払い
  Deferred = 'DEFERRED', // 先に建単、後で支払い
  AfterIssuance = 'AFTER_ISSUANCE' // 先に発券、後で支払い（企業契約等）
}
export type PaymentTiming = PaymentTimingEnum;

/**
 * 割引オプション（KNR 試算・注文作成の discountOption）
 * 管理 PC は固定で NONE を送信する（ドキュメント 4.1/5.2）
 */
export enum DiscountOptionEnum {
  None = 'NONE'
}
export type DiscountOption = DiscountOptionEnum;

/** KNR 注文系インターフェースの X-Device-Type ヘッダー値 */
export const KNR_DEVICE_TYPE = 'KNR';

/**
 * 運賃券種コード（dic_catalog: /items/ticketTypes の dataCode）
 */
export enum FareTicketTypeCodeEnum {
  SingleNormal = 'SINGLE_NORMAL' // 片道普通車両
}
export type FareTicketTypeCode = FareTicketTypeCodeEnum;

export enum BookingStatusEnum {
  BookingSubmitted = 'BOOKING_SUBMITTED', // 预约受付 | 11
  BookingOk = 'BOOKING_OK', // 预约OK | 12
  BookingNg = 'BOOKING_NG', // 预约NG | 13
  ChangeSubmitted = 'CHANGE_SUBMITTED', // 预约 変更受付 | 14
  ChangeOk = 'CHANGE_OK', // 预约変更OK | 15
  ChangeNg = 'CHANGE_NG', // 预约変更NG | 16
  CancellationSubmitted = 'CANCELLATION_SUBMITTED', // 取消受付 | 17
  CancellationConfirmed = 'CANCELLATION_CONFIRMED', // 取消確定 | 18
  Waitlist = 'WAITLIST' // 取消待ち | 19
}
export type BookingStatus = BookingStatusEnum;

// 団体予約一覧／検索の設計書に定義された表示順。
export const BOOKING_STATUS_DISPLAY_ORDER = [
  BookingStatusEnum.BookingSubmitted,
  BookingStatusEnum.ChangeSubmitted,
  BookingStatusEnum.CancellationSubmitted,
  BookingStatusEnum.BookingOk,
  BookingStatusEnum.BookingNg,
  BookingStatusEnum.ChangeOk,
  BookingStatusEnum.ChangeNg,
  BookingStatusEnum.CancellationConfirmed,
  BookingStatusEnum.Waitlist
] as const;

// 表示順に定義する。
export enum BookingSubStatusEnum {
  Initial = 'INITIAL',
  AllotmentConfirmed = 'ALLOTMENT_CONFIRMED',
  AllotmentNotAvailable = 'ALLOTMENT_NOT_AVAILABLE',
  SeatAssigning = 'SEAT_ASSIGNING',
  SeatReserved = 'SEAT_RESERVED',
  SeatNotAvailable = 'SEAT_NOT_AVAILABLE',
  SeatTableSent = 'SEAT_TABLE_SENT'
}
export type BookingSubStatus = BookingSubStatusEnum;

export enum HandCloseStatusEnum {
  Closing = 'CLOSING',
  Closed = 'CLOSED'
}
export type HandCloseStatus = HandCloseStatusEnum;

export enum BusinessTypeEnum {
  Restaurant = 'RESTAURANT', // レストラン
  Fare = 'FARE', // 運賃
  RebateRefund = 'REBATE_REFUND' // リベート返金
}
export type BusinessType = BusinessTypeEnum;

export const BusinessTypeLowercaseEnum = {
  restaurant: 'restaurant', // レストラン
  fare: 'fare' // 運賃
} as const;

export type BusinessTypeLowercase = Lowercase<`${BusinessTypeEnum}`>;

/**
 * 支払方法オプション取得のフェーズ（リクエスト送信用）
 */
export enum PaymentMethodPhaseEnum {
  BeforeFirst = 'BEFORE_FIRST', // 初回支払い前
  AfterFirst = 'AFTER_FIRST' // 初回支払い後（差額支払い）
}
export type PaymentMethodPhase = PaymentMethodPhaseEnum;

/**
 * 支払方法コード（バックエンドの支払方法マスタと同一コード）
 */
export enum PaymentMethodCodeEnum {
  ShipTicketReconciliation = 'SHIP_TICKET_RECONCILIATION' // 船券精算（差額支払い）
}
export type PaymentMethodCode = PaymentMethodCodeEnum;

/**
 * 契約区分
 */
export enum ContractTypeEnum {
  Contracted = 1, // 契約代理店
  NonContracted = 2, // 非契約代理店
  Individual = 3 // 個人団体
}
export type ContractType = ContractTypeEnum;

/**
 * 締日/支払日の種別
 * 後端の boolean (closingDayEndOfMonth / billingDayEndOfMonth) と対応：
 *   true  → EndOfMonth（月末）
 *   false → SpecifiedDay（指定日）
 */
export enum ClosingDateTypeEnum {
  EndOfMonth = 1,
  SpecifiedDay = 2
}
export type ClosingDateType = ClosingDateTypeEnum;

export enum TicketRebateSettingTypeEnum {
  Fare = '1',
  Restaurant = '2'
}
export type TicketRebateSettingType = TicketRebateSettingTypeEnum;

export enum BookingTypeEnum {
  GroupBooking = 'GROUP_BOOKING', // 团体预约
  Tour = 'TOUR' // ツアー予約
}
export type BookingType = BookingTypeEnum;

/**
 * ツアー予約作成ステータス
 */
export enum TourStatusEnum {
  Created = 'CREATED' // 作成済（それ以外は未作成扱い）
}
export type TourStatus = TourStatusEnum;

/**
 * ツアーカレンダーの登録状態（リクエスト送信用）
 */
export enum TourCalendarStatusEnum {
  Submitted = 'SUBMITTED', // 予約作成対象
  Cancel = 'CANCEL' // キャンセル対象
}
export type TourCalendarStatus = TourCalendarStatusEnum;

/**
 * ツアー予約作成ジョブの状態
 */
export enum TourCreationJobStatusEnum {
  Pending = 'PENDING', // 待機中
  Running = 'RUNNING', // 実行中
  Partial = 'PARTIAL', // 一部失敗
  Failed = 'FAILED' // 失敗
}
export type TourCreationJobStatus = TourCreationJobStatusEnum;

/**
 * 運賃種別（乗客Type)
 */
export enum FareTypeEnum {
  Adult = 'ADULT',
  Child = 'CHILD'
}
export type FareType = FareTypeEnum;

/**
 * 乗客カテゴリコード
 */
export enum PassengerCategoryEnum {
  General = 'GENERAL', // 一般
  Disabled = 'DISABLED', // 障害者
  Caregiver = 'CAREGIVER', // 介護者
  TourConductor = 'TOUR_CONDUCTOR' // 乗務員
}
export type PassengerCategory = PassengerCategoryEnum;

export const BookingServiceOrderMaxCount = 3;

export enum CalendarTypeEnum {
  Disabled = 0,
  Weekday = 1,
  Holiday = 2,
  CustomHoliday = 3,
  pickHoliday = 10,
  pickCustomHoliday = 11
}

export enum CustomBizDateEnum {
  Lock = 4,
  Using = 5,
  Reservation = 6,
  Release = 7,
  Released = 8,
  CheckIcon = 9,
  SeatSetting = 10
}

export const fromBizStatus = {
  [CustomBizDateEnum.Lock]: 0,
  [CustomBizDateEnum.Using]: 1,
  [CustomBizDateEnum.Reservation]: 2,
  [CustomBizDateEnum.Release]: 3,
  [CustomBizDateEnum.Released]: 4,
  [CustomBizDateEnum.CheckIcon]: 10,
  [CustomBizDateEnum.SeatSetting]: 11
};

export const toBizStatus: Record<number, CustomBizDateEnum> = {
  0: CustomBizDateEnum.Lock,
  1: CustomBizDateEnum.Using,
  2: CustomBizDateEnum.Reservation,
  3: CustomBizDateEnum.Release,
  4: CustomBizDateEnum.Released,
  10: CustomBizDateEnum.CheckIcon,
  11: CustomBizDateEnum.SeatSetting
};

export const calendarTypeMap = {
  [CalendarTypeEnum.Disabled]: 'disabled',
  [CalendarTypeEnum.Weekday]: 'weekday',
  [CalendarTypeEnum.Holiday]: 'holiday',
  [CalendarTypeEnum.CustomHoliday]: 'customHoliday',
  [CalendarTypeEnum.pickHoliday]: 'holiday',
  [CalendarTypeEnum.pickCustomHoliday]: 'customHoliday'
};

export const calendarBizTypeMap = {
  [CustomBizDateEnum.Lock]: 'lock',
  [CustomBizDateEnum.Using]: 'using',
  [CustomBizDateEnum.Reservation]: 'reservation',
  [CustomBizDateEnum.Release]: 'release',
  [CustomBizDateEnum.Released]: 'released',
  [CustomBizDateEnum.CheckIcon]: 'checkIcon',
  [CustomBizDateEnum.SeatSetting]: 'seatSetting'
};

export type CalendarType = CalendarTypeEnum;
export type CalendarBizType = CustomBizDateEnum;

export const fromHolidayBiz = {
  [CalendarTypeEnum.pickHoliday]: CalendarTypeEnum.Holiday,
  [CalendarTypeEnum.pickCustomHoliday]: CalendarTypeEnum.CustomHoliday
};

export const toHolidayBiz = {
  [CalendarTypeEnum.Holiday]: CalendarTypeEnum.pickHoliday,
  [CalendarTypeEnum.CustomHoliday]: CalendarTypeEnum.pickCustomHoliday
};

export enum TourBookingCalendarUIStatusEnum {
  Default = '', // 予約未作成
  RequestedAdd = 'REQUESTED_ADD', // 予約作成済（予約確定前）
  RequestedCancelled = 'REQUESTED_CANCELLED', // キャンセル対象（予約確定前）
  ConfirmedAdd = 'CONFIRMED_ADD', // 予約作成済（予約確定）
  ConfirmedCancelled = 'CONFIRMED_CANCELLED', // キャンセル対象（予約確定）
  Cancelled = 'CANCELLED', // キャンセル受付（旧レスポンス）
  CancellationReception = 'CANCELLATION_RECEPTION',
  Hidden = 'HIDDEN'
}
export type TourBookingCalendarUIStatus = TourBookingCalendarUIStatusEnum;

// 状態                        | 背景色 | マーク | 操作
// ----------------------------|--------|--------|-----
// デフォルト                    | 白     | なし   | ◯
// 予約未作成                    | 白     | ✔      | ◯
// 予約作成済（予約確定前）        | 白     | ○      | ○
// キャンセル対象（予約確定前）     | 白     | ×      | ×
// 予約作成済（予約確定）         | 黄色    | ○      | ○
// キャンセル対象（予約確定）      | 黄色    | ×      | ×
// 運行期間外                   | グレー  | なし    | ◯
// キャンセル受付                | グレー  | ×      | ×
export const TourBookingCalendarUIStatusMap = {
  [TourBookingCalendarUIStatusEnum.Default]: {
    icon: '✔',
    color: 'var(--color-white)'
  },
  [TourBookingCalendarUIStatusEnum.RequestedAdd]: {
    icon: '○',
    color: 'var(--color-white)'
  },
  [TourBookingCalendarUIStatusEnum.RequestedCancelled]: {
    icon: '×',
    color: 'var(--color-white)'
  },
  [TourBookingCalendarUIStatusEnum.ConfirmedAdd]: {
    icon: '○',
    color: 'var(--color-warning-light-selected)'
  },
  [TourBookingCalendarUIStatusEnum.ConfirmedCancelled]: {
    icon: '×',
    color: 'var(--color-warning-light-selected)'
  },
  [TourBookingCalendarUIStatusEnum.Cancelled]: {
    icon: '×',
    color: 'var(--color-disabled-bg)'
  },
  [TourBookingCalendarUIStatusEnum.CancellationReception]: {
    icon: '×',
    color: 'var(--color-disabled-bg)'
  },
  [TourBookingCalendarUIStatusEnum.Hidden]: {
    icon: undefined,
    color: undefined
  }
};

export enum RemarkScopeEnum {
  Public = 'PUBLIC',
  Internal = 'KKT'
}
export type RemarkScope = RemarkScopeEnum;

export enum DashboardContentScopeEnum {
  AgentPersonal = 'AGENT_PERSONAL',
  Internal = 'INTERNAL'
}
export type DashboardContentScope = DashboardContentScopeEnum;

export enum AgencyPageTypeEnum {
  Agency = 'agency',
  IndividualGroup = 'individualGroup'
}
export type AgencyPageType = AgencyPageTypeEnum;

export enum UserDetailPageTypeEnum {
  KKT = 'kkt',
  Agency = 'agency',
  Individual = 'individual'
}
export type UserDetailPageType = UserDetailPageTypeEnum;

// 席確保状況 と 確認/結果メールテンプレートの確認/結果
export enum SeatHoldStageEnum {
  SeatHold = 'SEAT_HOLD', // 席确保
  SeatAssignment = 'SEAT_ASSIGNMENT' // 席付
}
export type SeatHoldStage = SeatHoldStageEnum;

export enum ResultTypeEnum {
  Ok = 'OK',
  Ng = 'NG'
}
export type ResultType = ResultTypeEnum;

/** see: seat_adjustment_type table */
export enum SeatAdjustmentTypeIdEnum {
  Wheelchair = '3'
}
export type SeatAdjustmentTypeId = SeatAdjustmentTypeIdEnum;

// サイネージ表示設定コード（eUse02 サイネージ設定）
export enum SignageDisplaySettingCodeEnum {
  TimetableMessageArea = 'TIMETABLE_MESSAGE_AREA', // ダイヤ/メッセージエリア
  MessageTitleBody = 'MESSAGE_TITLE_BODY' // メッセージタイトル/メッセージ本体
}
export type SignageDisplaySettingCode = SignageDisplaySettingCodeEnum;

// サイネージ更新モード（eUse02 サイネージ設定）
export enum SignageUpdateModeEnum {
  Auto = 'AUTO', // 自動
  Manual = 'MANUAL' // 手動
}
export type SignageUpdateMode = SignageUpdateModeEnum;

// サイネージパネル位置（eUse02 サイネージ設定）
export enum SignagePanelPositionEnum {
  Left = 'LEFT', // 左側
  Right = 'RIGHT' // 右側
}
export type SignagePanelPosition = SignagePanelPositionEnum;

// サイネージメッセージ種別（eUse02 サイネージ設定）
export enum SignageMessageTypeEnum {
  Title = 'TITLE', // タイトル候補メッセージ
  Body = 'BODY', // 本文候補メッセージ
  Area = 'AREA' // エリア候補メッセージ
}
export type SignageMessageType = SignageMessageTypeEnum;

// 共通エラーコード（統合レスポンスの code。data.messageId は CommonMessageIdEnum を参照）
export enum CommonErrorCodeEnum {
  ConcurrentUpdate = '40009' // 楽観排他競合（他ユーザーが先に更新）
}
export type CommonErrorCode = CommonErrorCodeEnum;

// 共通エラーのメッセージ ID（統合レスポンス data.messageId）
export enum CommonMessageIdEnum {
  ParamInvalid = 'COMMON_PARAM_INVALID', // パラメータ不正
  ConcurrentUpdate = 'COMMON_CONCURRENT_UPDATE' // 楽観排他競合
}
export type CommonMessageId = CommonMessageIdEnum;
